import { Controller } from "@hotwired/stimulus"

let lastTrackedPath = null

export default class extends Controller {
  connect() {
    this.ensureVisitorCookie()
    this.trackPageview()
    this.onTurboLoad = () => this.trackPageview()
    this.onClick = (e) => this.trackClickEvent(e)
    this.onSubmit = (e) => this.trackFormSubmit(e)
    document.addEventListener("turbo:load", this.onTurboLoad)
    this.element.addEventListener("click", this.onClick)
    this.element.addEventListener("submit", this.onSubmit)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.onTurboLoad)
    this.element.removeEventListener("click", this.onClick)
    this.element.removeEventListener("submit", this.onSubmit)
  }

  trackPageview() {
    const path = location.pathname
    if (path === lastTrackedPath) return

    if (window.umami?.track) {
      window.umami.track((props) => ({ ...props, url: path }))
      lastTrackedPath = path
    }
  }

  trackClickEvent(e) {
    const el = e.target.closest("[data-umami-event]")
    if (!el || !window.umami?.track) return
    // Skip submit buttons inside forms — trackFormSubmit handles those
    if (el.type === "submit" && el.closest("form")) return
    window.umami.track(el.dataset.umamiEvent)
  }

  trackFormSubmit(e) {
    const btn = e.submitter?.dataset?.umamiEvent
      ? e.submitter
      : e.target.querySelector("[data-umami-event]")
    if (!btn || !window.umami?.track) return
    window.umami.track(btn.dataset.umamiEvent)
  }

  ensureVisitorCookie() {
    if (document.cookie.includes("_opentil_visitor")) return
    const bytes = crypto.getRandomValues(new Uint8Array(8))
    const hash = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("")
    document.cookie = `_opentil_visitor=${hash};path=/;max-age=31536000;SameSite=Lax`
  }
}
